// reqWx.js

const axios = require('axios');

const baseUrl = "http://localhost:8000"
const remoteUrl = "http://lcoalhost:6000"

// 定义发送 POST 请求的函数
async function sendPostRequest(path, data) {
    try {
        const response = await axios.post(baseUrl + path, data);
        return response.data;
    } catch (error) {
        console.error('Error sending POST request:', error.message);
        throw error;
    }
}

async function postRemoteData(path, data) {
    const response = await axios.post(remoteUrl + path, data);
    return response.data;
}

// 将函数暴露出去
module.exports = { sendPostRequest, postRemoteData };
